// Generated automatically by nearley, version unknown
// http://github.com/Hardmath123/nearley
(function () {
function id(x) { return x[0]; }
var grammar = {
    Lexer: undefined,
    ParserRules: [
    {"name": "expression", "symbols": ["expression", "operator", "word"], "postprocess": 
        function(data) {
            return {
                left: data[0],
                right: data[2],
                operator: data[1]
            }
        }
            },
    {"name": "expression", "symbols": ["word"]},
    {"name": "word$ebnf$1", "symbols": [/[a-zA-Z0-9\s]/]},
    {"name": "word$ebnf$1", "symbols": ["word$ebnf$1", /[a-zA-Z0-9\s]/], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "word", "symbols": ["word$ebnf$1"], "postprocess":  function(data, location) {
            return {
                type: "word",
                value: data[0].join(""),
                location: location
            };
        } },
    {"name": "operator", "symbols": [{"literal":"+"}], "postprocess": 
        function(data, location) {
            var d;
            if (Array.isArray(data[0])) {
                d = data[0].join("")
            }
            else {
                d = data
            }
            return {type: "operator", value: data, location: location}
        }
            },
    {"name": "operator", "symbols": [{"literal":"-"}], "postprocess": 
        function(data, location) { 
            var d;
            if (Array.isArray(data[0])) {
                d = data[0].join("")
            }
            else {
                d = data
            }
            return {type: "operator", value: data, location: location}
        }
            }
]
  , ParserStart: "expression"
}
if (typeof module !== 'undefined'&& typeof module.exports !== 'undefined') {
   module.exports = grammar;
} else {
   window.grammar = grammar;
}
})();



//////////////////
// WEBPACK FOOTER
// ./src/grammar.ne
// module id = 390
// module chunks = 0